"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 */
function formatErrorMessage(code, ...args) {
  const url = new URL(`https://base-ui.com/production-error/${code}`);
  args.forEach(arg => url.searchParams.append('args[]', arg));
  return `Base UI error #${code}; visit ${url} for the full message.`;
}